
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/key-agent-sign-up",
      function () {
        return require("private-next-pages/key-agent-sign-up.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/key-agent-sign-up"])
      });
    }
  